<template>
  <div class="d-flex flex-column align-items-center">
    <div v-if="error">
      <p>Fel från ePassi: {{ error }}</p>
    </div>

    <div v-if="result === 'reject'">
      <p>Betalning kunde ej genomföras</p>
    </div>
    <div v-if="result === 'cancel'">
      <p>Betalningen avbröts</p>
    </div>
    <div v-if="result === 'return' && !order">
      <p>Verifierar betalning...</p>
    </div>

    <!-- Show this component when successful payment has been verified server side -->
    <PaymentStatusComponent 
      v-if="order"
      :order="order"
      @done="payment_done"
    />

    <p style="margin-top: 128px;"></p>
  </div>
</template>

<script>
import axios from 'axios';
import PaymentStatusComponent from '@/view/pages/members/payment/PaymentStatusComponent.vue';

import { setKeyValue, getKeyValue } from '@/core/services/simpleStore';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';

export default {
  name: 'ReturnAllPaymentsPage',
  props: [],
  mixins: [ toasts ],
  components: {
    PaymentStatusComponent,
  },
  computed: {
    min_width() {
      return {
        'min-width': is_mobile() ? '460px' : '640px'
      };
    }
  },
  data() {
    return {
      selected_payment_method: null,
      shop_order_id: null,
      token: null,
      order: null,
      result: null,
      error: null,
      stamp: null,
      paid: null,
      mac: null
    };
  },
  async mounted() {
    this.shop_order_id = this.$route.params.shop_order_id;
    this.token = this.$route.params.token;
    this.result = this.$route.params.result;
    this.error = this.$route.query.error || null;
    this.stamp = this.$route.query.stamp || this.$route.query.STAMP || null;
    this.paid = this.$route.query.PAID || null;
    this.mac = this.$route.query.MAC || null;

    if (this.result === 'return') {
      try {
        // First: verify server-side MAC and store paid order
        if (this.stamp && this.paid && this.mac) {
          this.order = await this.post_epassi_return(this.token, this.shop_order_id, this.stamp, this.mac, this.paid);
        } else {
          console.warn('Missing one or more of STAMP, PAID, MAC', this.stamp, this.mac, this.paid);
        }
      } catch (e) {
        this.error = 'Verifiering av betalningen misslyckades';
        console.error(e);
      }
    }
    else {
      try {
        this.order = await this.get_order(this.token, this.shop_order_id);
      } catch (e) {
        this.error = 'Kunde inte hämta ordern';
      }
    }

  },
  methods: {
    payment_done(order) {
      if (order && order.redirect_url) {
        location.href = order.redirect_url;
      }
    },

    async post_epassi_return(token, shop_order_id, STAMP, MAC, PAID) {
      try {
        const res = await axios.post(`/shop_order/epassi/return/token/${token}/${shop_order_id}`, {
          STAMP,
          MAC,
          PAID
        });

        if (res.status === 201 || res.status === 200) {
          return res.data;
        }
      } catch (err) {
        console.error('post_epassi_return error', err);
        throw err;
      }

      throw 'unable to post_epassi_return order';
    },

    async get_order(token, shop_order_id) {
      try {
        const res = await axios.get(`/shop_order/token/${token}/${shop_order_id}`);
        if (res.status === 200) {
          return res.data;
        }
      } catch (err) {
        console.error('get_order error', err);
      }

      throw 'unable to get order';
    }
  }
};
</script>

<style lang="css" scoped>
.amount {
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
}

.info {
  color: #1a1a1d;
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
}
</style>
